<script>
import { Bar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Chart from 'chart.js'


Chart.Tooltip.positioners.smart = function(elements, eventPosition) {
  //'nearest'の座標を計算
  const pos = Chart.Tooltip.positioners.nearest.call(this, elements, eventPosition);
  if (!pos) return false;

  if (pos.x < 100) {
    //左端付近
    this._options.xAlign = 'left';
  } else if (pos.x > 800) {
    //右端付近
    this._options.xAlign = 'right';

  } else {
    //その他
    this._options.xAlign = 'center';
  }

  return pos;
};
export default {
  extends: Bar,
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    //Y軸の開始温度
    startTemp: { type: Number, default: 21 },
    //Y軸の終了温度
    endTemp: { type: Number, default: 40 }
  },
  data() {
    return {
      humsLabels: [],
      fixedWbgtTable: {},
      highlightedSensorId: null,
      sensorMetaMap: {}
    }
  },
  created() {
    this.initWbgtTable();
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    //軸ラベル装飾
    this.addPlugin({
      id: 'axis-styler',
      //チャート描画後
      afterDraw: (chart) => {
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        //チャートが生成されていなければ何もしない
        if (!chartArea) return;
        const numCols = this.humsLabels.length;
        const cellWidth = (chartArea.right - chartArea.left) / numCols;
        const numRows = this.endTemp - this.startTemp + 1;
        const cellHeight = (chartArea.bottom - chartArea.top) / numRows;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = 'bold 12px';
        ctx.fillStyle = '#000000';
        ctx.save();
        //Y軸タイトル描画
        const yTitleX = 10;
        const yTitleY = (chartArea.top + chartArea.bottom) / 2;
        ctx.translate(yTitleX, yTitleY);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText('気温 (℃)', 0, 0);
        //復元しないとX軸にも反映されてしまう。
        ctx.restore();
        ctx.save();
        //X軸タイトル描画
        const xTitleX = (chartArea.left + chartArea.right) / 2;
        const xTitleY = chartArea.top - cellHeight - 20;
        ctx.fillText('相対湿度 (%)', xTitleX, xTitleY);
        ctx.restore();
        //カスタムラベル（軸ラベルの大きさをマスの大きさと同じにするため）
        const drawBoxedLabel = (text, x, y) => {
          const centerX = x + (cellWidth/2);
          const centerY = y + (cellHeight/2);
          //背景色
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(x, y, cellWidth, cellHeight);
          //枠線
          ctx.lineWidth = 1;
          ctx.strokeStyle = '#000000';
          ctx.strokeRect(x, y, cellWidth, cellHeight);
          //文字色（文字だけ真ん中指定）
          ctx.fillStyle = '#000000';
          ctx.fillText(text, centerX, centerY);
        };
        //X軸ラベル描画設定
        this.humsLabels.forEach((hum, index) => {
          const x = chartArea.left + (cellWidth * index);
          const y = chartArea.top - cellHeight;
          drawBoxedLabel(hum, x, y);
        });
        //Y軸ラベル描画設定
        for (let i = 0; i < numRows; i++) {
          const t = this.startTemp + i;
          const y = chartArea.bottom - (cellHeight * (i+1));
          const x = chartArea.left - cellWidth;
          drawBoxedLabel(t, x, y);
        }
        ctx.restore();
      }
    });
    this.renderSensorMap()
  },
  watch: {
    itemList() {
      this.renderSensorMap()
    }
  },
  methods: {
    //日付文字列をフォーマット
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      const day = d.getDate();
      let hour = d.getHours();
      //2桁ゼロ埋め
      const min = ('0' + d.getMinutes()).slice(-2);
      //午前/午後判定
      const ampm = hour >= 12 ? 'PM' : 'AM';
      //0時は12時と表記
      hour = hour % 12;
      hour = hour ? hour : 12;
      return `${day}日 ${hour}:${min} ${ampm}`;
    },
    //WBGTテーブル作成
    initWbgtTable() {
      //湿度作成
      for (let i = 20; i <= 100; i += 5) {
        this.humsLabels.push(i);
      }
      //温度ごとのWBGT値
      const rawData = {
        40: [28,29,30,31,32,33,34,34,35,36,36,37,38,38,39,39,40],
        39: [27,28,29,30,31,32,33,33,34,35,35,36,37,37,38,38,39],
        38: [27,28,29,29,30,31,32,33,33,34,35,35,36,36,37,37,38],
        37: [26,27,28,29,29,30,31,32,32,33,34,34,35,35,36,36,37],
        36: [25,26,27,28,29,29,30,31,31,32,33,33,34,34,35,35,36],
        35: [24,25,26,27,28,28,29,30,30,31,32,32,33,33,34,34,35],
        34: [24,25,25,26,27,28,28,29,30,30,31,31,32,32,33,34,34],
        33: [23,24,25,25,26,27,27,28,29,29,30,30,31,31,32,33,33],
        32: [22,23,24,24,25,26,26,27,28,28,29,29,30,31,31,32,32],
        31: [21,22,23,24,24,25,26,26,27,27,28,29,29,30,30,31,31],
        30: [21,21,22,23,23,24,25,25,26,26,27,28,28,29,29,30,30],
        29: [20,21,21,22,23,23,24,24,25,26,26,27,27,28,28,29,29],
        28: [19,20,21,21,22,22,23,24,24,25,25,26,26,27,27,28,28],
        27: [18,19,20,20,21,22,22,23,23,24,24,25,25,26,26,27,27],
        26: [18,18,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26],
        25: [17,17,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25],
        24: [16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24],
        23: [15,16,16,17,18,18,19,19,20,20,20,21,21,22,22,23,23],
        22: [15,15,16,16,17,17,18,18,19,19,20,20,20,21,21,22,22],
        21: [14,14,15,15,16,16,17,17,18,18,19,19,19,20,20,21,21]
      };
      //配列化
      this.fixedWbgtTable = {};
      Object.keys(rawData).forEach(temp => {
        this.fixedWbgtTable[temp] = {};
        rawData[temp].forEach((val, idx) => {
          const hum = this.humsLabels[idx];
          this.fixedWbgtTable[temp][hum] = val;
        });
      });
    },
    //温度と湿度からWBGT値を取得
    getWbgtValue(temp, hum) {
      const t = Math.floor(temp);
      const h = Math.floor(hum / 5) * 5;
      if (this.fixedWbgtTable[t] && this.fixedWbgtTable[t][h] !== undefined) {
        return this.fixedWbgtTable[t][h];
      }
      return 0;
    },
    //WBGTの背景色
    getWbgtColor(val) {
      const wbgt = Number(val);
      //危険
      if (wbgt >= 31) return 'rgba(255, 50, 50, 0.8)'
      //厳重警戒
      if (wbgt >= 28) return 'rgba(255, 140, 0, 0.8)'
      //警戒
      if (wbgt >= 25) return 'rgba(255, 255, 0, 0.8)'
      //注意
      return '#ffffff';
    },
    //マスにあるデータ全てを取得
    getTargetSensors(sensors) {
      if (!sensors || sensors.length === 0) return [];
      if (this.highlightedSensorId) {
        return [...sensors].sort((a, b) => {
          if (a.sensor_id === this.highlightedSensorId) return -1;
          if (b.sensor_id === this.highlightedSensorId) return 1;
          return 0;
        });
      }
      return sensors;
    },
    //ヒートマップ描画
    renderSensorMap() {
      //行数
      const numRows = this.endTemp - this.startTemp + 1;
      const cellHeight = 20;
      const mapHeight = numRows * cellHeight;
      //センサー数
      const uniqueSensors = new Set(this.itemList.map(i => i.sensor_id)).size;
      //凡例の大体の高さ
      const legendHeight = (Math.ceil(uniqueSensors / 3) * 20) + 150;
      //全体の高さ
      const totalCanvasHeight = mapHeight + legendHeight;
      //親要素を指定
      if (this.$el) {
        this.$el.style.height = `${totalCanvasHeight}px`;
      }
      //センサーの色
      const cellSensorColorMap = {};
      //データ
      const cellRawDataMap = {};
      //センサー用カラー
      const sensorColorsList = [
        '#0000FF', '#006400', '#800080', '#000080', '#8B4513',
        '#008080', '#4B0082', '#2F4F4F', '#8B0000', '#008B8B',
        '#9400D3', '#556B2F', '#A52A2A', '#696969', '#191970'
      ];
      //凡例
      this.sensorMetaMap = {};
      let colorIndex = 0;
      this.itemList.forEach(item => {
        //グラフの範囲内（温度・湿度）のデータのみ表示
        const t = Math.floor(item.temperature);
        const h = Math.floor(item.humidity / 5) * 5;
        if (t >= this.startTemp && t <= this.endTemp && h >= 20 && h <= 100) {
          const key = `${t}_${h}`;
          //センサーの色と凡例の設定
          if (!this.sensorMetaMap[item.sensor_id]) {
            this.sensorMetaMap[item.sensor_id] = {
              color: sensorColorsList[colorIndex % sensorColorsList.length],
              location: item.location || '',
              id: item.sensor_id
            };
            colorIndex++;
          }
          //センサーの色と枠線を同じにする
          cellSensorColorMap[key] = this.sensorMetaMap[item.sensor_id].color;
          //ツールチップ表示用に生データを保存
          if (!cellRawDataMap[key]) {
            cellRawDataMap[key] = [];
          }
          cellRawDataMap[key].push(item);
        }
      });
      // 凡例の作成
      const sensorLegendDatasets = Object.values(this.sensorMetaMap).map(meta => ({
        type: 'bar',
        label: `(${meta.location}):${meta.id}`,
        //凡例の四角の中の色
        backgroundColor: meta.color,
        sensorId: meta.id,
        data: [],
        //データがある場合のみ凡例表示
        isSensorLegend: true
      }));

      const sensorLocationMap = {};
      const heatmapDatasets = []

      for (let i = 0; i < numRows; i++) {
        const currentDatasetIndex = sensorLegendDatasets.length + i;
        const t = this.startTemp + i;
        //マスの高さ
        let rowData = []
        //マスの色
        let rowColors = []
        let rowWbgtValues = []
        let rowBorderColors = []
        let rowBorderWidths = []
        //凡例用
        let rowSensorValues = []
        this.humsLabels.forEach((h, hIndex) => {
          //積み上げ棒グラフ
          rowData.push(1);
          //WBGT値と色を取得
          const wbgt = this.getWbgtValue(t, h);
          rowWbgtValues.push(wbgt);
          rowColors.push(this.getWbgtColor(wbgt));
          const key = `${t}_${h}`;
          //データあり
          if (cellSensorColorMap[key]) {
            rowBorderColors.push(cellSensorColorMap[key]);
            rowBorderWidths.push(3);
            const sensors = cellRawDataMap[key];
            rowSensorValues.push(sensors);

            if (sensors && sensors.length > 0) {
              sensors.forEach(s => {
                sensorLocationMap[s.sensor_id] = {
                  datasetIndex: currentDatasetIndex,
                  index: hIndex
                };
              });
            }
          } else {
            //データなし
            rowBorderColors.push('#000000');
            rowBorderWidths.push(1);
            rowSensorValues.push(null);
          }
        })
        heatmapDatasets.push({
          type: 'bar',
          label: 'Heatmap',
          data: rowData,
          backgroundColor: rowColors,
          borderColor: rowBorderColors,
          borderWidth: rowBorderWidths,
          borderSkipped: false,
          barPercentage: 1.0,
          //これを入れないと隙間出来る
          categoryPercentage: 1.0,
          xAxisID: 'x-axis-grid',
          yAxisID: 'y-axis-grid',
          isBackground: true,
          wbgtValues: rowWbgtValues,
          sensorValues: rowSensorValues
        })
      }

      const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 30, left: 70, right: 10, bottom: 10 }
        },
        onHover: () => {
          this.highlightedSensorId = null;
        },
        plugins: {
          datalabels: {
            formatter: function(value, context) {
              //WBGT値を取得して表示（0の場合は非表示）
              const wbgt = context.dataset.wbgtValues[context.dataIndex];
              return wbgt > 0 ? wbgt : '';
            },
            color: '#333',
            font: { size: 12, weight: 'bold' },
            anchor: 'center',
            align: 'center',
            offset: 0
          }
        },
        legend: {
          display: true,
          position: 'bottom',
          onClick: (e, legendItem) => {
            const chart = this.$data._chart;
            const ds = chart.data.datasets[legendItem.datasetIndex];

            if (ds && ds.sensorId) {
              this.highlightedSensorId = ds.sensorId;
              const loc = sensorLocationMap[ds.sensorId];
              if (loc) {
                const meta = chart.getDatasetMeta(loc.datasetIndex);
                const rect = meta.data[loc.index];
                if (rect) {
                  chart.tooltip._active = [rect];
                  chart.tooltip.update(true);
                  chart.render();
                }
              }
            }
          },
          labels: {
            //センサー凡例(isSensorLegend)のみを表示
            filter: function(item, chartData) {
              const ds = chartData.datasets[item.datasetIndex]
              return !!ds.isSensorLegend;
            }
          }
        },
        tooltips: {
          enabled: true,
          position: 'smart',
          intersect: true,
          bodySpacing: 4,
          filter: function(item, data) {
            const ds = data.datasets[item.datasetIndex]
            if (ds.isSensorLegend) return false;
            //実データのみ表示
            if (ds.isBackground) {
              const sensors = ds.sensorValues[item.index];
              return !!sensors;
            }
            return false;
          },
          callbacks: {
            labelColor: () => {
              return null;
            },
            title:() =>{
              return null;
            },
            beforeLabel: () => {
              return null;
            },
            label: () => {
              return null;
            },
            afterLabel: (tooltipItem, data) => {
              const ds = data.datasets[tooltipItem.datasetIndex];
              const sensors = ds.sensorValues[tooltipItem.index];
              if (!sensors) return null;

              const sortedSensors = this.getTargetSensors(sensors);
              const lines = [];

              sortedSensors.forEach((s) => {
                const wbgt = this.getWbgtValue(s.temperature, s.humidity);
                lines.push(this.formatDate(s.detectiondatetime));
                lines.push(`${s.location}`);
                lines.push(`${s.sensor_id}`);
                lines.push(`WBGT値：${wbgt}℃`);
                lines.push(`温度:${s.temperature}℃, 湿度:${s.humidity}%`);
                lines.push(``);
              });
              return lines;
            },
          }
        },
        scales: {
          xAxes: [
            {
              id: 'x-axis-grid',
              position: 'top',
              stacked: true,
              scaleLabel: { display: false },
              gridLines: { display: false, drawBorder: false },
              labels: this.humsLabels.map(h => h + ''),
              ticks: {
                fontColor: 'transparent',
                fontSize: 12,
                padding: 0
              }
            }
          ],
          yAxes: [
            {
              id: 'y-axis-grid',
              stacked: true,
              display: false,
              ticks: { stepSize: 1 }
            }
          ]
        }
      }
      //描画
      this.renderChart(
          {
            labels: this.humsLabels.map(h => h + ''),
            datasets: [...sensorLegendDatasets, ...heatmapDatasets]
          },
          options
      )
    }
  }
}
</script>